import type {
    CustomEventDispatcher,
    EmptyEventHandlerMap,
} from "./event-helper"

type EventList<T extends EmptyEventHandlerMap> = {
    [K in keyof T]: (evt: T[K]) => void
}

type EventArray<T extends EmptyEventHandlerMap> = [name: keyof T, handler: (evt: CustomEvent<T[keyof T]>) => void][]

/**
 * This is just to help keep the verbosity down of having a million
 * tracked event listeners that you then have to unlisten to.
 * Keeps everything neat in one class
 */
export class EventWrapper<T extends EmptyEventHandlerMap, R extends CustomEventDispatcher<T>> {
    #map: EventArray<T> = []
    constructor(public emitter: R) {}

    register(map: Partial<EventList<T>>) {
        Object.entries(map).forEach(([name, handler]) => {
            this.#map.push([name, handler])
            this.emitter.addEventListener(name, handler)
        })
    }

    removeListeners() {
        this.#map.forEach(([name, handler]) => {
            this.emitter.removeEventListener(name, handler)
        })
    }
}